export const productsRoutes = [
    {
        path: '/products',
        meta: { requiresHousehold: true },
        children: [
          {
            path: '',
            component: () => import(/* webpackChunkName: "myproducts" */ '@/features/products/views/MyProducts.vue'),
          },
          {
            path: 'items/:id',
            component: () => import(/* webpackChunkName: "product" */ '@/features/products/views/ProductItemDetails.vue'),
          },
          {
            path: 'categories',
            component: () => import(/* webpackChunkName: "product" */ '@/features/products/views/ProductCategory.vue'),
          }
        ]
    }
]
